export default "__VITE_ASSET__0a150f4a__"